import { Link, useParams } from "react-router-dom";
import TeamCard from "../components/TeamCard";
import type { AppDataState } from "../api/useAppData";

function formatGD(n: number) {
  return n > 0 ? `+${n}` : String(n);
}

export default function PlayerPage({ state }: { state: AppDataState }) {
  const { data } = state;
  const { person } = useParams<{ person: string }>();
  if (!data) return <p>Loading…</p>;
  const decoded = person ? decodeURIComponent(person) : "";
  const summary = data.playerSummaries.find((p) => p.person === decoded);

  if (!summary) {
    return (
      <>
        <h1>Player not found</h1>
        <p>
          <Link to="/players">← Back to players</Link>
        </p>
      </>
    );
  }

  return (
    <>
      <p>
        <Link to="/players">← Players</Link>
      </p>
      <h1>{summary.person}</h1>
      <div className="card">
        <div>
          Teams remaining: <strong>{summary.teamsRemaining}</strong>
        </div>
        <div>GD: {formatGD(summary.goalDifference)}</div>
        <div>GF: {summary.goalsFor}</div>
        <div>GA: {summary.goalsAgainst}</div>
        <div>
          Points: <strong>{summary.points}</strong>
        </div>
      </div>

      <h2 className="section">Teams</h2>
      <div className="team-grid">
        {summary.teams.map((t) => (
          <TeamCard key={t.team} team={t} showOwner={false} />
        ))}
      </div>
    </>
  );
}
